export default "__VITE_ASSET__CioL6lCs__"